export class Language {
    regionCode: string;
    localeCode: string;
    rfc: string;
    posix: string;

    constructor(locale: string) {
        const [localeCode, regionCode] = locale.split(/[-_]+/);
        this.regionCode = regionCode;
        this.localeCode = localeCode;
        this.rfc = `${localeCode}-${regionCode}`;
        this.posix = `${localeCode.toLowerCase()}_${regionCode.toUpperCase()}`;
    }

    getRfcLocale() {
        return this.rfc;
    }

    isCurrent() {
        return false;
    }

    getLanguageCode() {
        if (this.localeCode === this.regionCode) {
            return this.posix.toLowerCase();
        }
        return this.localeCode.toLowerCase();
    }

    getLanguage() {
        switch (this.localeCode) {
            case 'en':
                return 'English';
            case 'de':
                return 'Deutsch';
            case 'nl':
                return 'Nederlands';
            case 'fr':
                return 'français';
            case 'it':
                return 'italiano';
            case 'es':
                return 'español';
            case 'pt':
                return 'português';
            case 'ja':
                return '日本語';
            default:
                throw new Error('unsupported language');
        }
    }

    toString() {
        return this.posix;
    }
}

export class CurrentLanguage extends Language {
    constructor(locale: string) {
        super(locale);
    }

    isCurrent() {
        return true;
    }
}
